module.exports = __webpack_public_path__ + "static/media/view2.0de35894.jpeg";